/**
 * 开关量输出
 */
import fvAnimation from "./fvAnimation"
export default class fvOutputSwitch extends fvAnimation {
    constructor(shape){
        super(shape,"fvOutputSwitch");
        this.shape.innerText = "";
        this.sizeFunction = AsyncFunction("return " + this.expression + " ? " + this.expression + ":false");
    }

    async run(canvas,value){
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        if(size == "__defaule"){
            size = "...";
        }
        if(this.enum == true){
            for(var i in this.enuminfo){
                if(size == 1){
                    size = 1;
                }else if(size ==false){
                    size = 0;
                }
                var value = [i];
                if("no"+size == value[0]){
                    this.shape.innerText = this.enuminfo[i];
                    return;
                }else{
                    this.shape.innerText =  "";
                }
              }
        }else{
            if(size){
                this.shape.innerText = JSON.parse(this.onoff).on;
            }else{
                this.shape.innerText = JSON.parse(this.onoff).off;
            }
        }
        super.run();
    }
}



// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvOutputSwitch.js